export class Conta {
    id?: number = -1;
    banco: string = "";
    agencia: string = "";
    conta: string = "";
    tipo: string = "";
}